import { RiSparklingFill } from '@remixicon/react';
import { useTranslation } from 'react-i18next';
import './Sparkle.styles.css';
import { Container } from 'react-bootstrap';

function Sparkle() {
    const { t } = useTranslation();

    return (
        <Container className="py-5">
            <div className="loader-sparkle-content">
                <div className="loader-sparkle-icon">
                    <RiSparklingFill className="loader-sparkle-svg" />
                </div>
                <h2 className="loader-sparkle-title">{t('sparkle.preparation')}</h2>
                <p className="loader-sparkle-subtitle">{t('sparkle.generationInProgress')}</p>
                <div className="loader-sparkle-dots">
                    <span className="sparkle-dot"></span>
                    <span className="sparkle-dot"></span>
                    <span className="sparkle-dot"></span>
                </div>
            </div>
        </Container>
    );
}

export default Sparkle;
